const ReportTypesConfig = {
    collection: "report_types",
    fields: ["code", "sort", "name", ],
  
    adapter: class ReportType {
      constructor(reportType) {
        Object.assign(this, reportType);
      }
    }
  };
  
  export default ReportTypesConfig;
  